import type { ClassValue } from 'clsx';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

function cn(...args: ClassValue[]): string {
  return twMerge(clsx(args));
}

export default cn;
